import "./PropertiesMasonry.css";

import { ComponentPlaceholder } from "../componentPlaceholder/componentPlaceholder";
import { DEFAULT_BLACKLISTED_TRAITS } from "../../constants";
import PropTypes from "prop-types";
import { PropertyBadge } from "../Badges/PropertyBadge/PropertyBadge";
import { useGetPropertyCategory } from "../../hooks/useGetPropertyCategory";
import { useMemo } from "react";

export const PropertiesMasonry = ({
  properties,
  propertyFilter = "",
  highlightedProperty,
  setHighlightedProperty,
  onSelectProperty,
  canSelectProperty = () => true,
}) => {
  const getPropertyCategory = useGetPropertyCategory();
  const propertyEntries = useMemo(
    () =>
      Object.keys(properties)
        .filter(
          (key) =>
            !DEFAULT_BLACKLISTED_TRAITS.includes(key) &&
            key.toLowerCase().includes(propertyFilter.toLowerCase())
        )
        .map((key) => ({
          key: key,
          value: properties[key],
          category: getPropertyCategory(key),
        }))
        .sort(
          (a, b) =>
            a.category.priority - b.category.priority ||
            a.key.toLowerCase().localeCompare(b.key.toLowerCase())
        ),
    [properties, getPropertyCategory, propertyFilter]
  );

  return Object.keys(properties).length > 0 ? (
    <div className="properties-masonry">
      {propertyEntries.map(({ key, value }) => (
        <PropertyBadge
          key={key}
          technicalName={key}
          value={value}
          isHighlighted={highlightedProperty === key}
          // No handler, no click (and no pointer on the badge).
          setHighlighted={
            onSelectProperty
              ? canSelectProperty(key)
                ? () => onSelectProperty(key)
                : undefined
              : setHighlightedProperty &&
                (() =>
                  setHighlightedProperty((prev) => (prev === key ? null : key)))
          }
          propertyFilter={propertyFilter}
        />
      ))}
    </div>
  ) : (
    <ComponentPlaceholder icon="fa-solid fa-ban" />
  );
};

PropertiesMasonry.propTypes = {
  feature: PropTypes.object,
  properties: PropTypes.object,
  propertyFilter: PropTypes.string,
  highlightedProperty: PropTypes.string,
  setHighlightedProperty: PropTypes.func,
  // Click on a badge picks that property instead of toggling the highlight.
  onSelectProperty: PropTypes.func,
  // Which badges onSelectProperty handles; the others are not clickable.
  canSelectProperty: PropTypes.func,
};
